module.exports = __webpack_public_path__ + "static/media/study220518.67057d8e.png";